import numbro from 'numbro'; 

export function separateNumber (num, precision) {
    return numbro(num).format({
        thousandSeparated: true,
        ...(precision !== undefined && { mantissa: precision }),
    });
}
